import Navbar from "@/components/Navbar";
import MittelstandLanding from "@/components/MittelstandLanding";
import Footer from "@/components/Footer";
import { OrganizationJsonLd } from "@/components/JsonLd";
import PageMeta from "@/components/PageMeta";
import { useTranslation } from "react-i18next";

const MittelstandPage = () => {
  const { i18n } = useTranslation();
  const isDe = i18n.language?.startsWith("de");
  return (
    <div className="min-h-screen bg-background">
      <PageMeta
        title={
          isDe
            ? "Angebotsprozess automatisieren — für Maschinenbau & Mittelstand"
            : "Automate your quoting process — for mechanical engineering & Mittelstand"
        }
        description={
          isDe
            ? "Ein autonomes Agenten-System für Ihren Angebotsprozess. In Ihrer Cloud. In 90 Tagen live. Festpreis. Kein Abo."
            : "An autonomous agent system for your quoting process. In your cloud. Live in 90 days. Fixed price. No subscription."
        }
      />
      <OrganizationJsonLd />
      <Navbar />
      <main>
        <MittelstandLanding />
      </main>
      <Footer />
    </div>
  );
};

export default MittelstandPage;
